import { useState, useEffect, useRef, useCallback } from 'react';
import { getCropsAnalyticsSummaryData } from 'services/cropsAnalytics.service';
import { useAuth } from 'auth/AuthContext';

export const useCropsAnalyticsData = () => {
  const { user } = useAuth();
  const hasFetched = useRef(false);

  const [cropsAnalyticsData, setCropsAnalyticsData] = useState({
    agroDataToday: [],
    agroDataYesterday: [],
    agroDataGroupsMonitor: [],
    agroDataGroupsMonitorYesterday: [],
    agroDataLast7Days: [],
    agroDataLast30Days: [],
    pickingDataToday: [],
    pickingDataYesterday: [],
    pickingDataLast7Days: [],
    pickingDataLast30Days: [],
    packingDataToday: [],
    packingDataYesterday: [],
    packingDataLast7Days: [],
    packingDataLast30Days: [],
    workersByGroupYesterday: [],
    loading: false,
    error: null
  });

  const fetchCropsAnalyticsSummaryData = useCallback(async () => {
    if (!user?.farmId) {
      return;
    }

    try {
      setCropsAnalyticsData(prev => ({ ...prev, loading: true, error: null }));
      const data = await getCropsAnalyticsSummaryData(user.farmId);

      setCropsAnalyticsData(prev => ({
        ...prev,
        agroDataToday: data.agroDataToday || [],
        agroDataYesterday: data.agroDataYesterday || [],
        agroDataGroupsMonitor: data.agroDataGroupsMonitor || [],
        agroDataGroupsMonitorYesterday: data.agroDataGroupsMonitorYesterday || [],
        agroDataLast7Days: data.agroDataLast7Days || [],
        agroDataLast30Days: data.agroDataLast30Days || [],
        pickingDataToday: data.pickingDataToday || [],
        pickingDataYesterday: data.pickingDataYesterday || [],
        pickingDataLast7Days: data.pickingDataLast7Days || [],
        pickingDataLast30Days: data.pickingDataLast30Days || [],
        packingDataToday: data.packingDataToday || [],
        packingDataYesterday: data.packingDataYesterday || [],
        packingDataLast7Days: data.packingDataLast7Days || [],
        packingDataLast30Days: data.packingDataLast30Days || [],
        workersByGroupYesterday: data.workersByGroupYesterday || [],
        loading: false
      }));
    } catch (error) {
      console.error('Error fetching Crops Analytics summary:', error);
      setCropsAnalyticsData(prev => ({
        ...prev,
        loading: false,
        error: 'Failed to load Crops Analytics summary data'
      }));
    }
  }, [user?.farmId]);

  useEffect(() => {
    if (hasFetched.current) {
      return;
    }
    hasFetched.current = true;
    fetchCropsAnalyticsSummaryData();
  }, [fetchCropsAnalyticsSummaryData]);

  return { cropsAnalyticsData, refetch: fetchCropsAnalyticsSummaryData };
};
